var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletWithdrawIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#1C2127"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0614 31.9787H29.5219V33.9461H20.0288V38.9999L12.3896 31.3607L11 29.9678L19.8351 21.1294V26.0196H22.4405V27.9837H17.8676V25.8759L13.7791 29.9678L17.7541 33.9461L18.0614 34.2534V31.9787Z",
    fill: "#2764FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6771 24.0321L40.2876 25.4251L32.8387 32.8706V27.9804C30.0329 27.9804 27.227 27.9804 24.4178 27.9837V26.0196C27.8817 26.0163 31.3423 26.0163 34.8061 26.0163V28.124L38.898 24.0321L34.6124 19.7466V22.0246H23.1519V20.0572H32.645V15L41.6771 24.0321Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWithdrawIcon);
export default __webpack_public_path__ + "static/media/wallet-withdraw-icon.d2524172cadc4315acf52045a5291e7b.svg";
export { ForwardRef as ReactComponent };